import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  Tab,
  Nav,
  Dropdown,
  ListGroup,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  fetchSurvey,
  resetData,
  selectId,
  selectLoading,
} from "./surveySlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  encryptData,
  checkEmptyFields,
  showDialog,
  paramsMasterAll,
  setOptionsMaster,
  decryptData,
  paramsYesNoType,
  handleSetOptionsMaster,
  paramsYesNoType2,
  validateSections,
  showDialogHtml,
  formatterStatus,
  setOptionsMaster2,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { v4 as uuidv4 } from "uuid"; // Import UUID

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
  addParamItem,
  fetchParam,
  fetchParam2,
  fetchParam3,
  fetchParam4,
  selectDataParam,
  selectDataParam2,
  selectDataParam3,
  selectDataParam4,
} from "../param/paramSlice";
import debounce from "lodash/debounce";
import { fetchCustomer } from "../customer/customerSlice";
import SVG from "react-inlinesvg";
import { InputDateRangeForm } from "../../utility/InputDateRangeForm";
import { fetchBranch, selectBranch } from "../branch/branchSlice";
import { fetchUser, selectDataUser } from "../user/userSlice";

export const SurveyCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectId);
  const dataParam = useSelector(selectDataParam);

  const dataParam2 = useSelector(selectDataParam2);
  const dataParam3 = useSelector(selectDataParam3);
  const dataParam4 = useSelector(selectDataParam4);
  const dataBranch = useSelector(selectBranch);
  const dataUser = useSelector(selectDataUser);

  const { id } = useParams();

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(resetData());

      await dispatch(fetchSurvey({ ...paramsMasterAll }));

      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }

      await dispatch(
        fetchParam({
          ...paramsMasterAll,
          param_group_code: "SURVEY_ENTRY",
          is_active: true,
        })
      );
      await dispatch(
        fetchParam2({
          ...paramsMasterAll,
          param_group_code: "SURVEY_CATEGORY",
          is_active: true,
        })
      );
      await dispatch(
        fetchParam3({
          ...paramsMasterAll,
          param_group_code: "TEXT_FIELD",
          is_active: true,
        })
      );
      await dispatch(
        fetchParam4({
          ...paramsMasterAll,
          param_group_code: "CUSTOMER_GROUP",
          is_active: true,
        })
      );
      await dispatch(fetchBranch({ ...paramsMasterAll }));
      await dispatch(
        fetchUser({
          ...paramsMasterAll,
          roles_in: "COMPANY_SALES,COMPANY_SUPERVISOR",
          is_active: true,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [desc, setDesc] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [entry, setEntry] = useState("");
  const [mandatory, setMandatory] = useState("");
  const [category, setCategory] = useState("");
  const [cust, setCust] = useState("All");
  const [branch, setBranch] = useState("All");
  const [group, setGroup] = useState("All");
  const [sales, setSales] = useState("All");
  const [active, setActive] = useState(true);
  const [listCust, setListCust] = useState([]);
  const [listBranch, setListBranch] = useState([]);
  const [listGroup, setListGroup] = useState([]);
  const [listSales, setListSales] = useState([]);

  const [optionsCategory, setOptionsCategory] = useState([]);
  const [optionsEntry, setOptionsEntry] = useState([]);
  const [optionsCustomer, setOptionsCustomer] = useState([]);
  const [optionsBranch, setOptionsBranch] = useState([]);
  const [optionsGroup, setOptionsGroup] = useState([]);
  const [optionsTextField, setOptionsTextField] = useState([]);
  const [optionsSales, setOptionsSales] = useState([]);

  const [paramCode, setParamCode] = useState("");
  const [paramValue, setParamValue] = useState("");
  const [showParam, setShowParam] = useState(false);

  const handleCloseParam = () => {
    setParamCode("");
    setParamValue("");
    setShowParam(false);
  };

  const paramsId = {
    survey_id: id,
  };
  useEffect(() => {
    if (dataId) {
      setCode(dataId.survey_title);
      setDesc(dataId?.survey_desc);
      setStartDate(dataId?.survey_period_start);
      setEndDate(dataId?.survey_period_end);
      setEntry(dataId?.survey_entry);
      setMandatory(dataId?.survey_mandatory);
      setCategory(dataId?.survey_category);
      setActive(dataId?.is_active);

      const initCustomer = dataId?.survey_specific_customer.map((item) => {
        return {
          value: item.customer_code,
          label: item.customer_code + "-" + item.customer_store_name,
        };
      });

      const initBranch = dataId?.specific_branch.map((item) => {
        return {
          value: item.branch_code,
          label: item.branch_code + "-" + item.branch_name,
        };
      });

      const initGroup = dataId?.specific_customer_group.map((item) => {
        return {
          value: item.customer_group,
          label: item.customer_group + "-" + item.customer_group_name,
        };
      });
      const initSales = dataId?.survey_specific_user.map((item) => {
        return {
          value: item.user_id,
          label: item.username + "-" + item.name,
        };
      });

      setListCust(initCustomer);
      setListBranch(initBranch);
      setListGroup(initGroup);
      setListSales(initSales);

      setCust(initCustomer.length > 0 ? "Specific" : "All");
      setBranch(initBranch.length > 0 ? "Specific" : "All");
      setGroup(initGroup.length > 0 ? "Specific" : "All");
      setSales(initSales.length > 0 ? "Specific" : "All");

      const initData = dataId?.section.map((item, index) => {
        return {
          ...item,
          section_no: `section-${index + 1}`,
          id: index + 1,
          section_question: item?.section_question.map(
            (question, indexQuestion) => {
              console.log(question, `Question ${indexQuestion + 1}`);
              console.log(question?.question_rule, "question_rule");

              return {
                ...question,
                id: indexQuestion + 1,
                question_option: question?.question_option.map(
                  (option, indexOption) => {
                    return {
                      ...option,
                      rule_id: option?.question_rule[0]?.rule_id || null,
                      rule_type: option?.question_rule[0]?.rule_type || null,
                      rule_condition:
                        option?.question_rule[0]?.rule_condition || null,
                      rule_target:
                        option?.question_rule[0]?.rule_target || null,
                      rule_desc: option?.question_rule[0]?.rule_desc || null,
                    };
                  }
                ),
              };
            }
          ),
        };
      });

      setSections(initData);
      setActiveKey("section-1");

      console.log(initData);
    }
  }, [dataId]);

  useEffect(() => {
    handleSetOptionsMaster(
      dataParam,
      setOptionsEntry,
      "param_code",
      "param_value"
    );
    handleSetOptionsMaster(
      dataParam2,
      setOptionsCategory,
      "param_code",
      "param_value"
    );
    handleSetOptionsMaster(
      dataParam3,
      setOptionsTextField,
      "param_code",
      "param_value"
    );
    handleSetOptionsMaster(
      dataParam4,
      setOptionsGroup,
      "param_code",
      "param_value"
    );
    handleSetOptionsMaster(
      dataBranch,
      setOptionsBranch,
      "branch_code",
      "branch_name"
    );
  }, [dataParam, dataParam2, dataParam3, dataParam4, dataBranch]);

  useEffect(() => {
    if (dataUser.length > 0) {
      setOptionsMaster2(dataUser, setOptionsSales, "user_id", [
        "username",
        "name",
      ]);
    }
  }, [dataUser]);

  const [sections, setSections] = useState([
    {
      section_id: uuidv4(),
      section_no: "section-1",
      id: 1,
      section_title: "",
      section_desc: "",
      section_question: [
        {
          question_id: uuidv4(),
          id: 1,
          question_desc: "",
          question_type: "",
          question_required: "N",
          question_default_answer: "",
          question_option: [],
          question_rule: [],
        },
      ],
    },
  ]);

  function validateSections(sections) {
    const errors = [];

    sections.forEach((section, sectionIndex) => {
      const sectionNumber = sectionIndex + 1; // Tambahkan 1 ke index
      if (!section.section_title) {
        errors.push(`Section ke ${sectionNumber} title cannot be empty.`);
      }

      section.section_question.forEach((question, questionIndex) => {
        const questionNumber = questionIndex + 1; // Tambahkan 1 ke index
        if (!question.question_desc) {
          errors.push(
            `Section ke ${sectionNumber}, Question ke ${questionNumber} description cannot be empty.`
          );
        }

        if (
          ["DROPDOWN", "CHECKBOX", "RADIO_BUTTON"].includes(
            question.question_type
          )
        ) {
          question.question_option.forEach((option, optionIndex) => {
            const optionNumber = optionIndex + 1; // Tambahkan 1 ke index
            if (!option.option_code) {
              errors.push(
                `Section ke ${sectionNumber}, Question ke ${questionNumber}, Option ke ${optionNumber} code cannot be empty.`
              );
            }
          });
        }
      });
    });

    return errors.join("<br>"); // Gunakan <br> sebagai pemisah
  }

  const handleSave = async () => {
    const fields = [
      { value: code, message: "input title", valid: true },
      { value: mandatory, message: "input Mandatory ", valid: true },
      { value: startDate, message: "input time period", valid: true },
      { value: endDate, message: "input time period", valid: true },
      { value: category, message: "input Category", valid: true },
      { value: entry, message: "input entry", valid: true },
    ];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }

    const errors = validateSections(sections);

    console.log(errors, "errors");
    if (errors.length > 0) {
      return showDialogHtml(errors);
    }

    const params = {
      survey_id: id,
      survey_category: category,
      survey_entry: entry,
      survey_period_start: startDate,
      survey_period_end: endDate,
      survey_mandatory: mandatory,
      survey_title: code,
      survey_desc: desc,
      is_active: active,
      survey_specific_customer:
        cust === "All"
          ? []
          : listCust.map((item) => {
              return {
                customer_code: item.value,
              };
            }),

      specific_branch:
        branch === "All"
          ? []
          : listBranch.map((item) => {
              return {
                branch_code: item.value,
              };
            }),
      specific_customer_group:
        group === "All"
          ? []
          : listGroup.map((item) => {
              return {
                customer_group: item.value,
              };
            }),
      survey_specific_user:
        sales === "All"
          ? []
          : listSales.map((item) => {
              return {
                user_id: item.value,
              };
            }),
      section: sections,
    };

    console.log(params, "params");

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleChangeEntry = createChangeHandler(setEntry);

  const handleChangeCategory = createChangeHandler(setCategory);
  const handleChangeActive = createChangeHandler(setActive);
  const handleChangeMandatory = createChangeHandler(setMandatory);
  const handleChangeBranch = (selectedOptions) => {
    // Update state with selected options
    setListBranch(selectedOptions || []); // Jika tidak ada pilihan, set ke array kosong
  };
  const handleChangeGroup = (selectedOptions) => {
    // Update state with selected options
    setListGroup(selectedOptions || []); // Jika tidak ada pilihan, set ke array kosong
  };
  const handleChangeCustomer = (selectedOptions) => {
    // Update state with selected options
    setListCust(selectedOptions || []); // Jika tidak ada pilihan, set ke array kosong
  };
  const handleChangeSales = (selectedOptions) => {
    // Update state with selected options
    setListSales(selectedOptions || []); // Jika tidak ada pilihan, set ke array kosong
  };

  // Fungsi debounced untuk mendapatkan data dari API
  const fetchDataFromApi = debounce(async (inputValue) => {
    try {
      // Simulate fetching data from the server or another source
      const response = await dispatch(
        fetchCustomer({
          customer_code: inputValue,
          pageNo: 1,
          pageSize: 20,
        })
      );

      const newData = response.payload.data.data.map((e) => ({
        value: e.customer_code,
        label: `${e.customer_code} - ${e.customer_store_name}`,
      }));

      // Merge the new options with the existing options
      setOptionsCustomer((prevOptions) => {
        const mergedOptions = [...prevOptions, ...newData];

        // Remove duplicates by ensuring unique customer codes
        const uniqueOptions = mergedOptions.filter(
          (option, index, self) =>
            index === self.findIndex((o) => o.value === option.value)
        );

        return uniqueOptions;
      });
    } catch (error) {
      // Handle errors, e.g., log or show an error message
      console.error("Error fetching data:", error);
    }
  }, 1000);

  // suver form

  const [categories, setCategories] = useState([
    {
      name: "QUESTION",
      items: [],
    },
    {
      name: "SECTION",
      items: [],
    },
    {
      name: "OTHER",
      items: [
        {
          question_id: "END",
          question_no: "2",
          question_desc: "END",
          question_type: "END",
          question_answer: "END",
          rule_type: "END",
        },
      ],
    },
  ]);

  const [activeKey, setActiveKey] = useState("section-1"); // Menyimpan tab yang aktif

  const handleAddSection = () => {
    const newSectionId = sections.length + 1;
    const newSection = {
      id: newSectionId,
      section_no: `section-${newSectionId}`,
      section_id: uuidv4(),
      section_title: "",
      section_desc: "",
      section_question: [
        {
          question_id: uuidv4(),
          id: 1,
          question_desc: "",
          question_type: "",
          question_required: "N",
          question_default_answer: "",
          question_option: [],
          question_rule: [],
        },
      ], // Menambahkan 1 pertanyaan default
    };
    setSections([...sections, newSection]);
    setActiveKey(`section-${newSectionId}`); // Set tab yang baru dibuat aktif
  };

  const handleDeleteSection = (id) => {
    setSections((prevSections) => {
      const updatedSections = prevSections.filter(
        (section) => section.id !== id
      ); // Hapus section yang dipilih

      const newActiveKey =
        updatedSections.length > 0
          ? `section-${Math.min(id, updatedSections.length)}` // Set ke section sebelumnya
          : null;

      setActiveKey(newActiveKey); // Set tab yang aktif setelah penghapusan

      // Reindex sections
      return updatedSections.map((section, index) => ({
        ...section,
        id: index + 1,
      }));
    });
  };

  const handleSectionChange = (id, field, value) => {
    setSections((prevSections) =>
      prevSections.map((section) =>
        section.id === id ? { ...section, [field]: value } : section
      )
    );
  };

  const handleAddQuestion = (sectionId) => {
    setSections((prevSections) =>
      prevSections.map((section) =>
        section.id === sectionId
          ? {
              ...section,
              section_question: [
                ...section.section_question,
                {
                  id: section.section_question.length + 1,
                  question_id: uuidv4(),
                  question_desc: "",
                  question_type: "",
                  question_required: "N",
                  question_default_answer: "",
                  question_rule: [],
                  question_option: [],
                },
              ],
            }
          : section
      )
    );
  };

  const handleQuestionChange = (sectionId, questionId, field, value) => {
    setSections((prevSections) =>
      prevSections.map((section) =>
        section.id === sectionId
          ? {
              ...section,
              section_question: section.section_question.map((question) =>
                question.id === questionId
                  ? {
                      ...question,
                      [field]: value,
                      ...(field === "question_type" && {
                        question_option: [
                          {
                            option_id: uuidv4(),
                            option_code: "",
                            option_name: "",
                            rule_desc: "",
                            rule_target: "",
                            rule_type: "",
                            rule_code: "",
                          },
                        ],
                      }),
                    }
                  : question
              ),
            }
          : section
      )
    );
  };

  const handleAddOption = (sectionId, questionId) => {
    setSections((prevSections) =>
      prevSections.map((section) =>
        section.id === sectionId
          ? {
              ...section,
              section_question: section.section_question.map((question) =>
                question.id === questionId
                  ? {
                      ...question,
                      question_option: [
                        ...(question.question_option || []),
                        {
                          option_id: uuidv4(),
                          option_code: "",
                          option_name: "",
                          rule_desc: "",
                          rule_target: "",
                          rule_type: "",
                          rule_code: "",
                        },
                      ],
                    }
                  : question
              ),
            }
          : section
      )
    );
  };

  const handleOptionChange = (
    sectionId,
    questionId,
    optionIndex,
    field,
    value
  ) => {
    setSections((prevSections) =>
      prevSections.map((section) =>
        section.id === sectionId
          ? {
              ...section,
              section_question: section.section_question.map((question) =>
                question.id === questionId
                  ? {
                      ...question,
                      question_option: question.question_option.map(
                        (option, idx) =>
                          idx === optionIndex
                            ? {
                                ...option,
                                [field]: value,
                                ...(field === "option_code" && {
                                  option_name: value,
                                }),
                              }
                            : option
                      ),
                    }
                  : question
              ),
            }
          : section
      )
    );
  };

  const handleDeleteOption = (sectionId, questionId, optionIndex) => {
    setSections((prevSections) =>
      prevSections.map((section) =>
        section.id === sectionId
          ? {
              ...section,
              section_question: section.section_question.map((question) =>
                question.id === questionId
                  ? {
                      ...question,
                      question_option: question.question_option.filter(
                        (_, idx) => idx !== optionIndex
                      ),
                    }
                  : question
              ),
            }
          : section
      )
    );
  };

  // ADD RULE

  const [selectedValue, setSelectedValue] = useState("");
  const [activeDropdown, setActiveDropdown] = useState(null); // Track dropdown index

  const transformQUESTION = (data, indexQuestion) => {
    // Find the active section
    const activeSection = data.find(
      (section) => section.section_no === activeKey
    );

    // Make sure activeSection exists before attempting to map
    if (!activeSection) return [];

    // Map over the section_question in the active section
    const QUESTION = activeSection.section_question.map((question, index) => {
      return {
        rule_target: question.question_id,
        question_desc: question.question_desc,
        rule_type: "QUESTION",
        status: index <= indexQuestion ? true : false,
      };
    });

    return QUESTION;
  };
  const transformSECTION = (data, activeKey) => {
    const activeSectionIndex = data.findIndex(
      (section) => section.section_no === activeKey
    );

    if (activeSectionIndex === -1) return []; // Return empty array if the active section is not found

    return data.map((section, index) => ({
      rule_target: section.section_id,
      question_desc: section.section_title,
      rule_type: "SECTION",
      status: index <= activeSectionIndex ? true : false,
    }));
  };

  const toggleDropdown = (option, option_id, indexQuestion) => {
    setCategories([
      {
        name: "QUESTION",
        items: transformQUESTION(sections, indexQuestion),
      },
      {
        name: "SECTION",
        items: transformSECTION(sections, activeKey),
      },
      {
        name: "OTHER",
        items: [
          {
            rule_target: "END",
            question_desc: "END",
            rule_type: "QUESTION",
            status: false,
          },
        ],
      },
    ]);

    setActiveDropdown((prevState) =>
      prevState === option_id ? null : option_id
    ); // Toggle dropdown
  };

  const handleSelectChange = (sectionId, questionId, optionId, value) => {
    setSections((prevSections) =>
      prevSections.map((section) =>
        section.section_id === sectionId
          ? {
              ...section,
              section_question: section.section_question.map((question) =>
                question.question_id === questionId
                  ? {
                      ...question,
                      question_rule: (question.question_rule || []).some(
                        (rule) => rule.rule_condition === optionId
                      )
                        ? (question.question_rule || []).map((rule) =>
                            rule.rule_condition === optionId
                              ? {
                                  ...rule,
                                  rule_desc: value.question_desc || "",
                                  rule_target: value.rule_target || "",
                                  rule_type: value.rule_type || "",
                                  rule_code: value.rule_code || "",
                                }
                              : rule
                          )
                        : [
                            ...(question.question_rule || []),
                            {
                              rule_condition: optionId,
                              rule_desc: value.question_desc || "",
                              rule_target: value.rule_target || "",
                              rule_type: value.rule_type || "",
                              rule_code: value.rule_code || "",
                            },
                          ],
                      question_option: question.question_option.map((option) =>
                        option.option_id === optionId
                          ? {
                              ...option,
                              rule_desc: value.question_desc || "",
                              rule_target: value.rule_target || "",
                              rule_type: value.rule_type || "",
                              rule_code: value.rule_code || "",
                            }
                          : option
                      ),
                    }
                  : question
              ),
            }
          : section
      )
    );
    setActiveDropdown(null);
  };

  const handleSelectChangeNoOption = (
    sectionId,
    questionId,
    optionId,
    value
  ) => {
    setSections((prevSections) =>
      prevSections.map((section) =>
        section.section_id === sectionId
          ? {
              ...section,
              section_question: section.section_question.map((question) =>
                question.question_id === questionId
                  ? {
                      ...question,
                      question_rule: (question.question_rule || []).some(
                        (rule) => rule.rule_condition === questionId
                      )
                        ? (question.question_rule || []).map((rule) =>
                            rule.rule_condition === questionId
                              ? {
                                  ...rule,
                                  rule_desc: value.question_desc || "",
                                  rule_target: value.rule_target || "",
                                  rule_type: value.rule_type || "",
                                  rule_code: value.rule_code || "",
                                }
                              : rule
                          )
                        : [
                            ...(question.question_rule || []),
                            {
                              rule_condition: questionId,
                              rule_desc: value.question_desc || "",
                              rule_target: value.rule_target || "",
                              rule_type: value.rule_type || "",
                              rule_code: value.rule_code || "",
                            },
                          ],
                      question_option: question.question_option.map((option) =>
                        option.option_id === optionId
                          ? {
                              ...option,
                              rule_desc: value.question_desc || "",
                              rule_target: value.rule_target || "",
                              rule_type: value.rule_type || "",
                              rule_code: value.rule_code || "",
                            }
                          : option
                      ),
                    }
                  : question
              ),
            }
          : section
      )
    );
    setActiveDropdown(null);
    setCategories([]);
  };

  const handleResetValue = (sectionId, questionId, optionId) => {
    setSections((prevData) =>
      prevData.map((section) =>
        section.section_id === sectionId
          ? {
              ...section,
              section_question: section.section_question.map((question) =>
                question.question_id === questionId
                  ? {
                      ...question,
                      question_option: question.question_option.map((option) =>
                        option.option_id === optionId
                          ? {
                              ...option, // Pertahankan properti lainnya
                              rule_desc: "",
                              rule_target: "",
                              rule_type: "",
                              rule_code: "",
                            }
                          : option
                      ),
                      question_rule: question.question_rule.filter(
                        (rule) => rule.option_id !== optionId
                      ),
                    }
                  : question
              ),
            }
          : section
      )
    );
  };

  const handleParam = async () => {
    const fields = [
      { value: paramCode, message: "input Param Code", valid: true },
    ];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }

    const params = {
      param_group_code: "SURVEY_CATEGORY",
      param_code: paramCode,
      param_value: paramValue,
      // display_order: "1",
    };

    try {
      const response = await dispatch(addParamItem(params));
      if (response.payload.status === 200) {
        setOptionsCategory((prev) => [
          ...prev,
          {
            value: paramCode,
            label: paramValue,
          },
        ]);

        await handleCloseParam();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined ? "Create Survey" : "Edit Survey"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Title <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setCode(e.target.value)}
                      value={code}
                      disabled={id !== undefined ? true : false}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Description</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      as="textarea"
                      onChange={(e) => setDesc(e.target.value)}
                      value={desc}
                      disabled={id !== undefined ? true : false}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Mandatory <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={paramsYesNoType2}
                      value={getValueStatus(mandatory, paramsYesNoType2)}
                      placeholder="Select ..."
                      onChange={handleChangeMandatory}
                      // isClearable={true}
                      isDisabled={id !== undefined ? true : false}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      {" "}
                      Entry<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsEntry}
                      value={getValueStatus(entry, optionsEntry)}
                      placeholder="Select ..."
                      onChange={handleChangeEntry}
                      // isClearable={true}
                      isDisabled={id !== undefined ? true : false}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Branch <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Button
                      className="mr-2"
                      variant={branch === "All" ? "danger" : "outline-danger"}
                      onClick={() => setBranch("All")}
                      disabled={id !== undefined ? true : false}
                    >
                      All Branch
                    </Button>
                    <Button
                      variant={
                        branch === "Specific" ? "danger" : "outline-danger"
                      }
                      onClick={() => setBranch("Specific")}
                      disabled={id !== undefined ? true : false}
                    >
                      Specific Branch
                    </Button>

                    {branch === "Specific" && (
                      <div style={{ marginBottom: "10px" }} className="mt-5">
                        <strong>Select Specific Branch</strong>
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          options={optionsBranch}
                          value={listBranch}
                          placeholder="Select ..."
                          onChange={handleChangeBranch}
                          isMulti
                          isDisabled={id !== undefined ? true : false}
                        />
                      </div>
                    )}
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Cust Group <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Button
                      className="mr-2"
                      variant={group === "All" ? "danger" : "outline-danger"}
                      onClick={() => setGroup("All")}
                      disabled={id !== undefined ? true : false}
                    >
                      All Group
                    </Button>
                    <Button
                      variant={
                        group === "Specific" ? "danger" : "outline-danger"
                      }
                      onClick={() => setGroup("Specific")}
                      disabled={id !== undefined ? true : false}
                    >
                      Specific Group
                    </Button>

                    {group === "Specific" && (
                      <div style={{ marginBottom: "10px" }} className="mt-5">
                        <strong>Select Specific Group</strong>
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          options={optionsGroup}
                          value={listGroup}
                          placeholder="Select ..."
                          onChange={handleChangeGroup}
                          isMulti
                          isDisabled={id !== undefined ? true : false}
                        />
                      </div>
                    )}
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                {id !== undefined && (
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b> Status</b>
                    </Form.Label>
                    <Col sm={6}>{formatterStatus(dataId?.status)}</Col>
                  </Form.Group>
                )}

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      {" "}
                      Period <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <InputDateRangeForm
                      setEndDate={setEndDate}
                      setStartDate={setStartDate}
                      endDate={endDate}
                      startDate={startDate}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      {" "}
                      Category<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsCategory}
                      value={getValueStatus(category, optionsCategory)}
                      placeholder="Select ..."
                      onChange={handleChangeCategory}
                      // isClearable={true}
                      isDisabled={id !== undefined ? true : false}
                    />
                  </Col>
                  {id === undefined && (
                    <Col md={1}>
                      <button
                        type="button" // Tambahkan ini
                        className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3 mb-2 mt-1"
                        onClick={() => setShowParam(true)}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-danger">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Code/Plus.svg"
                            )}
                          />
                        </span>
                      </button>
                    </Col>
                  )}
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      {" "}
                      Is Active <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={paramsYesNoType}
                      value={getValueStatus(active, paramsYesNoType)}
                      placeholder="Select ..."
                      onChange={handleChangeActive}
                      // isClearable={true}
                      // isDisabled={id !== undefined ? true : false}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Customer <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Button
                      className="mr-2"
                      variant={cust === "All" ? "danger" : "outline-danger"}
                      onClick={() => setCust("All")}
                      disabled={id !== undefined ? true : false}
                    >
                      All Customer
                    </Button>
                    <Button
                      variant={
                        cust === "Specific" ? "danger" : "outline-danger"
                      }
                      onClick={() => setCust("Specific")}
                      disabled={id !== undefined ? true : false}
                    >
                      Specific Customer
                    </Button>

                    {cust === "Specific" && (
                      <div style={{ marginBottom: "10px" }} className="mt-5">
                        <strong>Select Specific Customer</strong>
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          options={optionsCustomer}
                          value={listCust}
                          placeholder="Select ..."
                          onChange={handleChangeCustomer}
                          onInputChange={(inputValue) => {
                            fetchDataFromApi(inputValue);
                          }}
                          isMulti
                          isDisabled={id !== undefined ? true : false}
                        />
                      </div>
                    )}
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Sales<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Button
                      className="mr-2"
                      variant={sales === "All" ? "danger" : "outline-danger"}
                      onClick={() => setSales("All")}
                      disabled={id !== undefined ? true : false}
                    >
                      All Sales
                    </Button>
                    <Button
                      variant={
                        sales === "Specific" ? "danger" : "outline-danger"
                      }
                      onClick={() => setSales("Specific")}
                      disabled={id !== undefined ? true : false}
                    >
                      Specific Sales
                    </Button>

                    {sales === "Specific" && (
                      <div style={{ marginBottom: "10px" }} className="mt-5">
                        <strong>Select Specific Sales</strong>
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          options={optionsSales}
                          value={listSales}
                          placeholder="Select ..."
                          onChange={handleChangeSales}
                          isMulti
                          isDisabled={id !== undefined ? true : false}
                        />
                      </div>
                    )}
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </CardBody>

        {/* SURVEY FORM */}
        <hr />
        <CardHeader>
          <CardHeaderTitle className="card-title">Survey Form</CardHeaderTitle>
        </CardHeader>
        <CardBody>
          <Tab.Container activeKey={activeKey} onSelect={setActiveKey}>
            <Nav variant="tabs" className="mb-3">
              {sections.map((section) => (
                <Nav.Item key={section.id}>
                  <Nav.Link eventKey={`section-${section.id}`}>
                    Section {section.id}
                  </Nav.Link>
                </Nav.Item>
              ))}
              {id === undefined && (
                <button
                  className="btn btn-success ms-3"
                  onClick={handleAddSection}
                >
                  Add Section
                </button>
              )}
            </Nav>
            <Tab.Content>
              {sections.map((section) => (
                <Tab.Pane key={section.id} eventKey={`section-${section.id}`}>
                  <div className="border rounded p-3 mb-4">
                    <h5 className="text-primary d-flex justify-content-between">
                      Section {section.id}
                      {id === undefined && (
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDeleteSection(section.id)}
                          disabled={sections.length === 1}
                        >
                          Delete Section
                        </button>
                      )}
                    </h5>
                    <Form.Group as={Row}>
                      <Form.Label column sm={2}>
                        <b>
                          Section Title <b className="color-red">*</b>
                        </b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          onChange={(e) =>
                            handleSectionChange(
                              section.id,
                              "section_title",
                              e.target.value
                            )
                          }
                          value={section.section_title}
                          disabled={id !== undefined ? true : false}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={2}>
                        <b>Description </b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          as="textarea"
                          onChange={(e) =>
                            handleSectionChange(
                              section.id,
                              "section_desc",
                              e.target.value
                            )
                          }
                          value={section.section_desc}
                          disabled={id !== undefined ? true : false}
                        />
                      </Col>
                    </Form.Group>
                    <hr />

                    {section.section_question.map((question, indexQuestion) => (
                      <div key={question.id} className="mt-3">
                        <b>Question:</b>

                        <Row>
                          <Col md={6}>
                            <Form.Control
                              as="textarea"
                              placeholder="Add question"
                              onChange={(e) =>
                                handleQuestionChange(
                                  section.id,
                                  question.id,
                                  "question_desc",
                                  e.target.value
                                )
                              }
                              value={question.question_desc}
                              disabled={id !== undefined ? true : false}
                            />
                          </Col>
                          <Col md={4}>
                            <Select
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              options={optionsTextField}
                              value={optionsTextField.find(
                                (option) =>
                                  option.value === question.question_type
                              )} // Cocokkan objek berdasarkan nilai
                              placeholder="Select Type"
                              onChange={(selectedOption) =>
                                handleQuestionChange(
                                  section.id,
                                  question.id,
                                  "question_type",
                                  selectedOption?.value // Gunakan nilai dari opsi yang dipilih
                                )
                              }
                              isDisabled={id !== undefined ? true : false}
                            />
                          </Col>
                          <Col sm="1">
                            <div className="form-check form-switch mx-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={question.question_required === "Y"}
                                onChange={(e) =>
                                  handleQuestionChange(
                                    section.id,
                                    question.id,
                                    "question_required",
                                    e.target.checked ? "Y" : "N" // Convert true/false to 'Y'/'N'
                                  )
                                }
                                disabled={id !== undefined ? true : false}
                              />
                              <label className="form-check-label">
                                Required
                              </label>
                            </div>
                          </Col>
                          {id === undefined && (
                            <Col md={1}>
                              <button
                                className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3 mb-2"
                                onClick={() =>
                                  setSections((prevSections) =>
                                    prevSections.map((sec) =>
                                      sec.id === section.id
                                        ? {
                                            ...sec,
                                            section_question: sec.section_question.filter(
                                              (q) => q.id !== question.id
                                            ),
                                          }
                                        : sec
                                    )
                                  )
                                }
                              >
                                <span className="svg-icon svg-icon-md svg-icon-danger">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/General/Trash.svg"
                                    )}
                                  />
                                </span>
                              </button>
                            </Col>
                          )}
                        </Row>
                        {["DROPDOWN", "CHECKBOX", "RADIO_BUTTON"].includes(
                          question.question_type
                        ) ? (
                          <div className="mt-3">
                            <Row className="mb-2">
                              <Col md={5}>
                                <b>Options:</b>
                              </Col>
                              <Col md={6}>
                                <b>Rules:</b>
                              </Col>
                            </Row>
                            {(question.question_option || []).map(
                              (option, index) => (
                                <Row key={index} className="mb-2">
                                  <Col md={5}>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Option"
                                      value={option.option_code}
                                      onChange={(e) =>
                                        handleOptionChange(
                                          section.id,
                                          question.id,
                                          index,
                                          "option_code",
                                          e.target.value
                                        )
                                      }
                                      disabled={id !== undefined ? true : false}
                                    />
                                  </Col>

                                  {id === undefined && (
                                    <Col md={1}>
                                      {question.question_option.length > 1 && (
                                        <button
                                          className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3 mb-2"
                                          onClick={() =>
                                            handleDeleteOption(
                                              section.id,
                                              question.id,
                                              index
                                            )
                                          }
                                        >
                                          <span className="svg-icon svg-icon-md svg-icon-danger">
                                            <SVG
                                              src={toAbsoluteUrl(
                                                "/media/svg/icons/General/Trash.svg"
                                              )}
                                            />
                                          </span>
                                        </button>
                                      )}
                                    </Col>
                                  )}

                                  <Col
                                    md={5}
                                    className="d-flex align-items-center justify-content-between"
                                    style={{
                                      overflowWrap: "break-word",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {/* rule dropdown */}
                                    {id === undefined ? (
                                      question.question_type === "CHECKBOX" &&
                                      question.question_option.some(
                                        (opt) => opt.rule_desc && opt !== option
                                      ) ? (
                                        // Hide dropdown if another rule is already filled
                                        <div className="text-muted">
                                          Rule sudah diisi di opsi lain.
                                        </div>
                                      ) : (
                                        <Dropdown
                                          show={
                                            activeDropdown === option.option_id
                                          }
                                          onToggle={() =>
                                            toggleDropdown(
                                              option,
                                              option.option_id,
                                              indexQuestion
                                            )
                                          }
                                        >
                                          <Dropdown.Toggle
                                            variant="outline-primary"
                                            id="dropdown-basic"
                                            style={{
                                              maxWidth: "300px",
                                              minWidth: "300px",
                                              width: "100%",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {option?.rule_desc || "+ Add Rule"}
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu
                                            className="p-0"
                                            style={{
                                              maxWidth: "300px",
                                              minWidth: "300px",
                                              width: "100%",
                                            }}
                                          >
                                            <Card
                                              className="p-3"
                                              style={{
                                                width: "100%",
                                                maxWidth: "300px",
                                              }}
                                            >
                                              {categories.map((category) => (
                                                <div
                                                  key={category.name}
                                                  className="mb-4"
                                                >
                                                  <h6 className="text-muted">
                                                    {category.name}
                                                  </h6>
                                                  <ListGroup>
                                                    {category.items.map(
                                                      (item) => (
                                                        <ListGroup.Item
                                                          key={item.question_id}
                                                          action
                                                          disabled={item.status}
                                                          onClick={() =>
                                                            handleSelectChange(
                                                              section.section_id,
                                                              question.question_id,
                                                              option.option_id,
                                                              item
                                                            )
                                                          }
                                                          className={`d-flex justify-content-between align-items-center ${
                                                            selectedValue ===
                                                            item.question_id
                                                              ? "bg-primary text-white"
                                                              : ""
                                                          }`}
                                                        >
                                                          <div
                                                            style={{
                                                              overflow:
                                                                "hidden",
                                                              textOverflow:
                                                                "ellipsis",
                                                              whiteSpace:
                                                                "nowrap",
                                                            }}
                                                          >
                                                            <strong>
                                                              {item.no}.
                                                            </strong>{" "}
                                                            {item.question_desc}
                                                          </div>
                                                          {selectedValue ===
                                                            item.question_id && (
                                                            <i className="bi bi-check-circle-fill"></i>
                                                          )}
                                                        </ListGroup.Item>
                                                      )
                                                    )}
                                                  </ListGroup>
                                                </div>
                                              ))}
                                              <div className="d-flex justify-content-between mt-3">
                                                <Button
                                                  variant="secondary"
                                                  size="sm"
                                                  onClick={() =>
                                                    setActiveDropdown(null)
                                                  }
                                                >
                                                  Close
                                                </Button>
                                              </div>
                                            </Card>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      )
                                    ) : (
                                      <Form.Control
                                        type="text"
                                        disabled
                                        value={option?.rule_desc}
                                      />
                                    )}

                                    {/* reset rule */}
                                    {id === undefined &&
                                      option?.rule_desc !== "" && (
                                        <button
                                          className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3 mb-2"
                                          onClick={(e) =>
                                            handleResetValue(
                                              section.section_id,
                                              question.question_id,
                                              option.option_id
                                            )
                                          }
                                        >
                                          <span className="svg-icon svg-icon-md svg-icon-danger">
                                            <SVG
                                              src={toAbsoluteUrl(
                                                "/media/svg/icons/Navigation/Close.svg"
                                              )}
                                            />
                                          </span>
                                        </button>
                                      )}
                                  </Col>
                                </Row>
                              )
                            )}

                            {id === undefined && (
                              <button
                                className="btn btn-primary btn-sm mt-2"
                                onClick={() =>
                                  handleAddOption(section.id, question.id)
                                }
                              >
                                Add Option
                              </button>
                            )}
                          </div>
                        ) : (
                          <div className="mt-3">
                            <Row className="mb-2">
                              <Col md={5}>
                                <b>Options:</b>
                              </Col>
                              <Col md={6}>
                                <b>Rules:</b>
                              </Col>
                            </Row>
                            {(question.question_option || []).map(
                              (option, index) => (
                                <Row key={index} className="mb-2">
                                  <Col md={5}>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder={question.question_type}
                                      disabled
                                    />
                                  </Col>
                                  {id === undefined && <Col md={1}></Col>}
                                  <Col
                                    md={5}
                                    className="d-flex align-items-center justify-content-between"
                                  >
                                    {id === undefined ? (
                                      <Dropdown
                                        show={
                                          activeDropdown === option.option_id
                                        }
                                        onToggle={() =>
                                          toggleDropdown(
                                            option,
                                            option.option_id,
                                            indexQuestion
                                          )
                                        }
                                      >
                                        <Dropdown.Toggle
                                          variant="outline-primary"
                                          id="dropdown-basic"
                                          style={{
                                            maxWidth: "300px", // Panjang maksimal yang konsisten
                                            minWidth: "300px", // Panjang minimal yang konsisten
                                            width: "100%", // Sesuaikan dengan elemen induk
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {// Jika ada rule yang cocok, tampilkan rule_desc, jika tidak tampilkan "+ Add Rule"
                                          option?.rule_desc || " + Add Rule"}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu className="p-0">
                                          <Card
                                            className="p-3"
                                            style={{ minWidth: "300px" }}
                                          >
                                            {categories.map((category) => (
                                              <div
                                                key={category.name}
                                                className="mb-4"
                                              >
                                                <h6 className="text-muted">
                                                  {category.name}
                                                </h6>
                                                <ListGroup>
                                                  {category.items.map(
                                                    (item) => (
                                                      <ListGroup.Item
                                                        key={item.question_id}
                                                        disabled={item.status}
                                                        action
                                                        onClick={() =>
                                                          handleSelectChange(
                                                            section.section_id,
                                                            question.question_id,
                                                            option.option_id,
                                                            item
                                                          )
                                                        }
                                                      >
                                                        <div>
                                                          {/* <strong>
                                                        {item.no}
                                                      </strong>{" "} */}
                                                          {item.question_desc}
                                                        </div>
                                                        {selectedValue ===
                                                          item.question_id && (
                                                          <i className="bi bi-check-circle-fill"></i>
                                                        )}
                                                      </ListGroup.Item>
                                                    )
                                                  )}
                                                </ListGroup>
                                              </div>
                                            ))}
                                            <div className="d-flex justify-content-between mt-3">
                                              <Button
                                                variant="secondary"
                                                size="sm"
                                                onClick={() =>
                                                  setActiveDropdown(null)
                                                }
                                              >
                                                Close
                                              </Button>
                                            </div>
                                          </Card>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    ) : (
                                      <Form.Control
                                        type="text"
                                        disabled
                                        value={option?.rule_desc}
                                      />
                                    )}

                                    {!id && option?.rule_desc && (
                                      <button
                                        className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3 mb-2"
                                        onClick={(e) =>
                                          handleResetValue(
                                            section.section_id,
                                            question.question_id,
                                            option.option_id
                                          )
                                        }
                                      >
                                        <span className="svg-icon svg-icon-md svg-icon-danger">
                                          <SVG
                                            src={toAbsoluteUrl(
                                              "/media/svg/icons/Navigation/Close.svg"
                                            )}
                                          />
                                        </span>
                                      </button>
                                    )}
                                  </Col>
                                </Row>
                              )
                            )}
                          </div>
                        )}
                        <hr />
                      </div>
                    ))}

                    {id === undefined && (
                      <button
                        className="btn btn-primary mt-3"
                        onClick={() => handleAddQuestion(section.id)}
                      >
                        Add Question
                      </button>
                    )}
                  </div>
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Tab.Container>
        </CardBody>
      </Card>

      <Modal
        show={showParam}
        onHide={handleCloseParam}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    Category Name <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    onChange={(e) => setParamCode(e.target.value)}
                    value={paramCode}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Category Value</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    onChange={(e) => setParamValue(e.target.value)}
                    value={paramValue}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseParam()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleParam}>
            Submit
          </Button>{" "}
        </Modal.Footer>
      </Modal>
    </>
  );
};
